import useStore from "../../../../context/useStore";

const FlotteStatutBadge = ({ statut }) => {
  const [state] = useStore();

  const statutsConstant = state?.constant?.items?.FLOTTE?.STATUTS_VEHICULE;

  const statutRef = statutsConstant?.find((s) => s.id == statut);

  if (!statutRef) return null;

  return (
    <span
      className="badge shadow font-weight-light"
      style={{
        background: statutRef.color || "#000",
        color: "white",
        fontSize: 12,
        whiteSpace: "wrap",
      }}
    >
      {statutRef.name}
    </span>
  );
};

export default FlotteStatutBadge;
